import { styled, Typography } from '@mui/material';

import { Colors } from 'Themes/colors';

/**
 * Shared base styles for organization text display
 * Used by both CourseCard and SimpleCourseCard components
 */
export const OrganizationText = styled(Typography)`
  color: ${Colors.darkGrey};
  font-size: 0.875rem;
  font-weight: 500;
`;

/**
 * Organization text with margin-bottom for detailed course cards
 */
export const OrganizationTextWithMargin = styled(OrganizationText)`
  margin-bottom: 4px !important;
`;
